import { GenIcon } from '../helpers/IconBase.es.js';

const BackToTopOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.25 4.48647C4.25073 4.07226 4.58711 3.73707 5.00132 3.73779L19.0013 3.76242C19.4155 3.76315 19.7507 4.09953 19.75 4.51374C19.7492 4.92796 19.4129 5.26315 18.9986 5.26242L4.99868 5.23779C4.58447 5.23706 4.24927 4.90069 4.25 4.48647ZM5.47789 14.6947C5.77525 14.983 6.25007 14.9757 6.53843 14.6784L11.25 9.81955V20C11.25 20.4142 11.5858 20.75 12 20.75C12.4142 20.75 12.75 20.4142 12.75 20V9.81955L17.4616 14.6784C17.7499 14.9757 18.2247 14.983 18.5221 14.6947C18.8195 14.4063 18.8268 13.9315 18.5384 13.6341L12.5384 7.44664C12.3972 7.30097 12.2029 7.21875 12 7.21875C11.7971 7.21875 11.6028 7.30097 11.4616 7.44664L5.46158 13.6341C5.17322 13.9315 5.18053 14.4063 5.47789 14.6947Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { BackToTopOutlined };
